export enum MinimalFormProceedDialogMode {
  IncompleteInformation = 'IncompleteInformation',
  NoAvailableApiProducts = 'NoAvailableApiProducts',
  ApiProductsAvailable = 'ApiProductsAvailable',
}
